import { render, staticRenderFns } from "./regulManager.vue?vue&type=template&id=bf74b542"
import script from "./regulManager.vue?vue&type=script&lang=js"
export * from "./regulManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf74b542')) {
      api.createRecord('bf74b542', component.options)
    } else {
      api.reload('bf74b542', component.options)
    }
    module.hot.accept("./regulManager.vue?vue&type=template&id=bf74b542", function () {
      api.rerender('bf74b542', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/chm/mail/regulManager.vue"
export default component.exports